import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/payjet_logo_neu.png'
import _imports_1 from '@/assets/Rectangle_6833.png'


const _hoisted_1 = { class: "flex min-h-full bg-white rounded rounded-2xl rounded-5" }
const _hoisted_2 = {
  class: "flex flex-1 flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24",
  style: {"width":"calc(50vw - 12px)"}
}
const _hoisted_3 = { class: "mx-auto w-full max-w-sm lg:w-96" }
const _hoisted_4 = { class: "mt-8" }
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = { class: "space-y-6" }
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = { class: "space-y-1" }
const _hoisted_9 = { class: "mt-1" }
const _hoisted_10 = {
  key: 0,
  class: "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative",
  role: "alert"
}
const _hoisted_11 = { class: "block sm:inline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("div", null, [
          _createElementVNode("img", {
            alt: "Workflow",
            class: "h-12 w-auto",
            src: _imports_0
          }),
          _createElementVNode("h2", { class: "mt-6 text-3xl font-bold tracking-tight text-gray-900" }, "Logge dich ein")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"hidden\"><div><div class=\"mt-1 grid grid-cols-1 gap-3\"><div><a class=\"text-center inline-flex w-full justify-center rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-500 shadow-sm hover:bg-gray-50\" href=\"#\"> Magic Link </a></div></div></div><div class=\"relative mt-6\"><div aria-hidden=\"true\" class=\"absolute inset-0 flex items-center\"><div class=\"w-full border-t border-gray-300\"></div></div><div class=\"relative flex justify-center text-sm\"><span class=\"bg-white px-2 text-gray-500\">order direkt einloggen</span></div></div></div>", 1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _cache[3] || (_cache[3] = _createElementVNode("label", {
                  class: "block text-sm font-medium text-gray-700",
                  for: "email"
                }, "E-Mail-Adresse", -1)),
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    id: "email",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                    autocomplete: "email",
                    class: "block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm",
                    name: "email",
                    required: "",
                    type: "email"
                  }, null, 512), [
                    [_vModelText, _ctx.email]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[4] || (_cache[4] = _createElementVNode("label", {
                  class: "block text-sm font-medium text-gray-700",
                  for: "password"
                }, "Passwort", -1)),
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    id: "password",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                    autocomplete: "current-password",
                    class: "block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm",
                    name: "password",
                    required: "",
                    type: "password"
                  }, null, 512), [
                    [_vModelText, _ctx.password]
                  ])
                ])
              ]),
              _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"flex items-center justify-between\"><div class=\"flex items-center\"><input id=\"remember-me\" class=\"h-4 w-4 rounded rounded-2xl border-gray-300 text-indigo-600 focus:ring-indigo-500\" name=\"remember-me\" type=\"checkbox\"><label class=\"ml-2 block text-sm text-gray-900\" for=\"remember-me\">Login speichern</label></div><div class=\"text-sm\"><a class=\"font-medium text-indigo-600 hover:text-indigo-500\" href=\"/passwordreset\">Passwort vergessen?</a></div></div>", 1)),
              (_ctx.loginerror)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.loginerror), 1),
                    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  class: "flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dologin()))
                }, " Login ")
              ])
            ])
          ])
        ])
      ])
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "relative hidden w-0 flex-1 lg:block" }, [
      _createElementVNode("img", {
        alt: "",
        class: "rounded-r rounded-r-3 absolute inset-0 h-full w-full object-cover",
        src: _imports_1
      })
    ], -1))
  ]))
}